module.exports = __webpack_public_path__ + "img/background.b115ff05.jpg";